module.exports = __webpack_public_path__ + "static/img/hero_shape_2.c39c0b6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/hero_shape_2.png
// module id = 50Nw
// module chunks = 0